const color = {
  "number": "#A44C89",
  "vector2": "#FF4B54",
  "vector3": "#FF7F42",
  "vector4": "#FEB13B",
  "sampler2D": " #CC4474"
}

export default color;
